import React, { Component } from 'react';
import { Form, Header, Icon, Loader, Popup, Segment, SegmentGroup, Table, Button } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import axios from 'axios';
import PaginationFront from '../../util/PaginationFront';
import SearchTableData from '../../util/SearchTableData';

class AdminUsers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            results: [],
            loading: true,
            activePage: 1,
            postsPerPage: 20,
            selectedRoleName: null,
        };

        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        axios.get(`/user/get-all-admins`)
            .then(res => {
                const filtered = (res.data || []).filter(u => {
                    const fn = (u.firstName || '').toUpperCase();
                    const ln = (u.lastName || '').toUpperCase();
                    return !(fn.includes('UTIC') || ln.includes('UTIC'));
                });

                this.setState({
                    users: this.groupUsersByPerson(filtered).sort((a, b) => (a.roleName || '').localeCompare(b.roleName || '')),
                    loading: false,
                });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    groupUsersByPerson(users) {
        const grouped = {};

        users.forEach(user => {
            const key = [
                user.personId || '',
                (user.firstName || '').trim().toLowerCase(),
                (user.lastName || '').trim().toLowerCase(),
                user.organizationalUnitName || '',
                user.roleName || ''
            ].join('|');
            const emails = (user.email || '').split(',')
                .map(email => email.trim())
                .filter(email => email && email.toLowerCase().includes('unsa.ba'));

            if (!grouped[key]) {
                grouped[key] = {
                    ...user,
                    emails
                };
            } else {
                grouped[key].emails = grouped[key].emails.concat(emails);
            }
        });

        return Object.values(grouped).map(user => {
            const uniqueEmails = Array.from(new Set(user.emails));
            const { emails, ...rest } = user;
            return {
                ...rest,
                email: uniqueEmails.join(', ')
            };
        });
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, { activePage: 1 });
    }

    getDataToRender() {
        let data = this.state.results.length !== 0 ? this.state.results : this.state.users;
        if (this.state.selectedRoleName) {
            data = data.filter(u => u.roleName === this.state.selectedRoleName);
        }
        return data;
    }

    getRoleOptions() {
        const roles = [...new Set(this.state.users.map(u => u.roleName)
            .filter(Boolean))];
        return roles.map(role => ({
            key: role,
            text: role,
            value: role
        }));
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage });

    copyAllEmails = () => {
        const emails = this.getDataToRender()
            .reduce((acc, u) => acc.concat((u.email || '').split(',').map(email => email.trim())), [])
            .filter(email => email && email.toLowerCase().includes('unsa.ba'));
        if (emails.length === 0) {
            toast('Nema email adresa za kopiranje.');
            return;
        }
        const uniqueEmails = Array.from(new Set(emails));
        navigator.clipboard.writeText(uniqueEmails.join(', '))
            .then(() => {
                toast('Email adrese su uspješno kopirane.');
            })
            .catch(() => {
                toast('Greška prilikom kopiranja email adresa.');
            });
    };

    renderEmails(email) {
        const emails = (email || '').split(',')
            .map(value => value.trim())
            .filter(value => value && value.toLowerCase().includes('unsa.ba'));

        if (emails.length === 0) {
            return '-';
        }

        return emails.map(value => <div key={value}>{value}</div>);
    }

    render() {
        const { loading } = this.state;

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender()
            .slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                <Header as="h1">{'Korisnici'}</Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">{'Spisak administratora'}</Header>
                    </Segment>
                    {(!loading) && (
                        <Segment>
                            <Form>
                                <Form.Select
                                    search
                                    clearable
                                    fluid
                                    label="Uloga"
                                    placeholder="Odaberite korisničku ulogu"
                                    disabled={loading}
                                    options={this.getRoleOptions()}
                                    value={this.state.selectedRoleName}
                                    onChange={(e, { value }) => {
                                        this.setState({
                                            selectedRoleName: value || null,
                                            activePage: 1
                                        });
                                    }}
                                />
                            </Form>
                        </Segment>
                    )}
                    <Segment>
                        {loading ? (
                            <div style={{
                                paddingTop: '20px',
                                paddingBottom: '20px'
                            }}>
                                <Loader active inline="centered"/>
                            </div>
                        ) : this.getDataToRender().length > 0 ? (
                            <Table selectable celled compact verticalAlign={'middle'}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={21}>
                                            <SearchTableData
                                                profMozilla
                                                data={this.state.users}
                                                getResults={this.getResults}
                                                filterItem={['firstName', 'lastName', 'email', 'organizationalUnitName', 'roleName']}
                                            />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={1}>R. br.</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={5}>Ime i prezime</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={5}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between'
                                            }}>
                                                <span>Email</span>
                                                <Popup
                                                    content="Kopiraj sve email adrese"
                                                    position={'top center'}
                                                    trigger={
                                                        <Button
                                                            circular
                                                            icon
                                                            compact
                                                            basic
                                                            color="teal"
                                                            onClick={this.copyAllEmails}
                                                            aria-label="Kopiraj sve email adrese"
                                                        >
                                                            <Icon name="copy outline"/>
                                                        </Button>
                                                    }
                                                />
                                            </div>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan={5}>Članica</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={5}>Uloga</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {currentPosts.map((user, index) => (
                                        <Table.Row key={index}>
                                            <Table.Cell colSpan={1} verticalAlign="middle" textAlign="left">{indexOfFirstPost + index + 1}.</Table.Cell>
                                            <Table.Cell
                                                verticalAlign="middle"
                                                textAlign="left"
                                                colSpan={5}>{`${user.firstName || ''} ${user.lastName || ''}`.trim() || '-'}</Table.Cell>
                                            <Table.Cell colSpan={5} verticalAlign="middle" textAlign="left">{this.renderEmails(user.email)}</Table.Cell>
                                            <Table.Cell colSpan={5} verticalAlign="middle" textAlign="left">{user.organizationalUnitName || '-'}</Table.Cell>
                                            <Table.Cell colSpan={5} verticalAlign="middle" textAlign="left">{user.roleName || '-'}</Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        ) : (
                            'Nema podataka za prikaz.'
                        )}
                        {currentPosts.length > 0 && !loading &&
                            <PaginationFront
                                postsPerPage={this.state.postsPerPage}
                                totalPosts={this.getDataToRender().length}
                                paginate={this.handlePaginationChange}
                                activePage={this.state.activePage}
                            />}
                    </Segment>
                </SegmentGroup>
                <ToastContainer hideProgressBar/>
            </div>
        );
    }
}

export default AdminUsers;



// WEBPACK FOOTER //
// ./src/views/Admin/AdminUsers/AdminUsers.js